import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Product } from '../../product/Product'

import { WorkOrderItem } from '../WorkOrderItem'

@InputType()
export class CheckAllItemAvailabilityArgs extends ActionArgs {
  @Field(() => [WorkOrderItem])
  items: WorkOrderItem[]
}

export interface ICheckAllItemAvailability extends IAction<Product, CheckAllItemAvailabilityArgs> {}
